import { getAxiosInstance } from '../blocks/axios/axiosFactory';

const url = "/client";

export default class ClientService {
    static get() {
        return getAxiosInstance().get(`${url}/get`);
    }

    static getSubsidies() {
        return getAxiosInstance().get(`${url}/getSubsidies`);
    }

    static getCoupons() {
        return getAxiosInstance().get(`${url}/getCoupons`);
    }

    static getCardInfo(cardSerialNumber: string) {
        return getAxiosInstance().get(`${url}/getCard/${cardSerialNumber}`);
    }
}
